import React from "react";
import moment from "moment";

interface DateRendererProp
{
    value: string;
    type?: string;
    timezone?: boolean;
}

class DateRenderer extends React.Component<DateRendererProp>
{
    static defaultProps = {};
    render(): React.ReactNode 
    {
        if (!this.props.value)
            return <b> - </b>;

        const ssDate = this.props.value.includes("/");
        const date = moment(this.props.value, "YYYY-MM-DDTHH:mm:ss");
        let datestring = date;

        if (this.props.timezone)
        {
            datestring = moment.utc(date).toDate();
        }

        return <b>{
            this.props.type == "short"
                ?
                ssDate ? moment(datestring, "MM/DD/YYYY").format("MM/DD/YYYY") : moment(datestring, "YYYY-MM-DDTHH:mm:ss").format("MM/DD/YYYY")
                :
                moment(datestring, "YYYY-MM-DDTHH:mm:ss").format("MMM DD, YYYY")
        }</b>;
    }
}

DateRenderer.defaultProps = {
    type: "short",
    timezone: false
};

export default DateRenderer;